import { useQuery } from '@tanstack/react-query';
import { useTour } from '@reactour/tour';
import Api, { withAcl } from 'hooks/Api';
import { useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import { ApiError, Lead, Task } from 'utils/types';

import c, { DEMO_ACCOUNT_USER, DEMO_CONTACT } from '../utils/constants';

export default function useGetTask(id?: string) {
  const { state } = useProvider();
  const { accountId, accountUserId } = useAdminParams();
  const { isOpen } = useTour();
  const args = state;

  return useQuery<Task, ApiError>({
    queryKey: [c.TASKS, id],
    queryFn: async () => {
      if (isOpen) {
        return {
          _id: 'test_task',
          id: 'test_task',
          accountId: '',
          dueAt: new Date().toISOString(),
          entryType: 'task',
          title: 'Demo Task',
          content: 'Demo Content',
          leadId: DEMO_CONTACT.value,
          accountUserId: [DEMO_ACCOUNT_USER.value],
          priority: 'HIGH',
          type: 'TODO',
          lead: DEMO_CONTACT as unknown as Lead,
          status: 'PENDING',
          accountUsers: [DEMO_ACCOUNT_USER as any],
        };
      }

      const api = new Api(args);

      const data = await api.get(
        await withAcl({
          account: {
            url: `api/v1/tasks/${id}`,
            params: {
              include: ['lead', 'accountUsers', 'attachments', 'tag', 'deal'],
              status: 'ALL',
            },
          },
          admin: {
            url: `api/v2/accounts/${accountId}/users/${accountUserId}/tasks/${id}`,
            params: {
              include: ['lead', 'accountUsers', 'attachments', 'tag', 'deal'],
              status: 'ALL',
            },
          },
        }),
      );

      return data?.data;
    },
    enabled: !!id,
  });
}
